import { SIDE_CENTER, SIDE_LEFT, SIDE_RIGHT } from '../../../constants'

export const IMAGE_SETTINGS = {
  [SIDE_LEFT]: {
    maxSize: 960,
    defaultSize: 160,
    sizes: '(min-width: 1920px) 480px, (min-width: 1200px) 24vw, 98vw',
    lazy: true,
    placeholder: false,
  },
  [SIDE_RIGHT]: {
    maxSize: 960,
    defaultSize: 160,
    sizes: '(min-width: 1920px) 480px, (min-width: 1200px) 24vw, 98vw',
    lazy: true,
    placeholder: false,
  },
  [SIDE_CENTER]: {
    minSize: 320,
    maxSize: 1840,
    defaultSize: 320,
    sizes: '(min-width: 1920px) 920px, (min-width: 1200px) 48vw, 98vw',
    lazy: true,
    placeholder: false,
  },
}
